import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import styles from './lowConfidenceText.module.scss'
import BtnPrimary from 'components/generic/BtnPrimary'
import ModalWTN from 'components/generic/ModalWTN'
import { useModalDispatch, useModalState, withModals } from 'hooks/use-modal'
import ConfidenceModalContent from 'components/search/CombinedRatingFilter/ConfidenceModalContent'
import cx from 'classnames'
import modalStyles from '../../search/CombinedRatingFilter/combinedRatingFilter.module.scss'

const modalId = 'confidence-win-loss-modal'

const LowConfidenceText = () => {
  const { t } = useTranslation(['strCommonUI', 'strFilters'])
  const { modalActions, modalDispatch } = useModalDispatch(modalId as never)
  const { isOpen } = useModalState(modalId as never)

  return (
    <div className={styles.textContainer}>
      <Trans ns='strH2H' i18nKey='winLikelihood.lowConfidence'>
        <p className={styles.text}>
          Both players must have verified World Tennis Numbers for an accurate prediction to
          display.
        </p>{' '}
        <BtnPrimary
          linkStyle
          onClick={() => modalDispatch(modalActions.openModal())}
          className={styles.text}
          buttonProps={{
            'aria-expanded': isOpen,
          }}
        >
          Understanding verification
        </BtnPrimary>
      </Trans>
      <ModalWTN
        widgetElId='player-profile'
        modalId={modalId}
        btnAlignment='right'
        btnSecondary={{
          text: t('button.close', { ns: 'strCommonUI' }),
          onClick: () => {
            modalDispatch(modalActions.closeModal())
          },
        }}
        textHeader={t('confidenceModal.title', { ns: 'strFilters' })}
        className={cx(modalStyles.infoModalConfidence, modalStyles.override)}
      >
        <ConfidenceModalContent />
      </ModalWTN>
    </div>
  )
}

export default withModals(LowConfidenceText, {
  modals: {
    [modalId]: {
      isOpen: false,
    },
  },
})
